import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import './TCModal.css'
import styles from './TCModal.module.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';

const TCModal = ({ showTCModal, setShowTCModal, showRefundModal, setShowRefundModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowTCModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("termsConditions", msisdn);
    analyticEvent('termsConditions', 'termsConditions-view')
    // pushCleverTapEvent('CheckIn-TC');
  }, [])

  return (
    <>
      <div className={styles.tcModal}>
        <div className={styles.tcModalHeader}>
          <div className="headerTitle" style={{marginBottom: '8px'}}>
            <img src={require('./tc.png')} className={styles.tcModalIcon} alt="terms" />
            <span className={styles.tcModalTitle}>নিয়ম ও শর্তাবলী</span>
          </div>
          <p className={styles.tcModalDescription}>
            QUIZARD কুইজ গেমে আপনাকে স্বাগতম ! QUIZARD এ কুইজ খেলে দৈনিক, সাপ্তাহিক, টুর্নামেন্ট ভিত্তিক আকর্ষণীয় পুরস্কার জিতে নিন । পাশাপাশি নিজের সাধারণ জ্ঞান ভিত্তিক দক্ষতা ও যাচাই করে ফেলুন । খেলা শুরু করার আগে, অনুগ্রহ করে আপনি নিচের নিয়ম ও শর্তাবলী মনোযোগ সহকারে পড়ুন এবং বুঝুন । এই কুইজ খেলায় অংশগ্রহণ করে, আপনি নিম্নলিখিত শর্তাবলী মেনে চলতে সম্মত হোন।
          </p>
        </div>

        <div className={styles.tcModalContent}>
          <Accordion className={styles.accordion}>
            <Accordion.Item eventKey="0" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>খেলার যোগ্যতা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                QUIZARD কুইজ গেমটি সকল বয়সের এবং জাতীয়তার বাক্তিদের জন্য উন্মুক্ত । কিন্তু, যে কোনো ধরনের প্রতারণা, বাহ্যিক সাহায্যের ব্যবহার, বা কুইজ প্ল্যাটফর্মের সাথে হেরফের করার প্রচেষ্টা অবিলম্বে অযোগ্যতার কারণ হবে। অযোগ্য অংশগ্রহণকারীরা কোনো পুরস্কার বা পুরস্কারের জন্য যোগ্য হবে না। আয়োজক সত্তার কর্মচারী এবং পরিবারের সদস্যরা অংশগ্রহণের যোগ্য নন।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>লিংক</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <a href="https://www.quizard.live/" target="_blank" rel="noopener noreferrer">https://www.quizard.live/</a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কীভাবে যোগদান করবেন</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                সাপ্তাহিক ৩০ টাকা চার্জে কুইজ প্রতিদিন, স্পোর্টস কুইজ, BCS প্রস্তুতি  এবং টুর্নামেন্ট ৩০ টাকা চার্জে কুইজ গুলো তে আপনি কুইজ খেলতে পারবেন | বিকাশ পেমেন্ট এর মাধ্যমে ব্যবহারকারীরা তাদের অ্যাকাউন্টটির সাবস্ক্রিপশন সম্পন্ন করতে পারবেন আর QUIZARD এ যোগদান করতে পারবেন ।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ খেলার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>QUIZARD কুইজ গেমটিতে কুইজ প্রতিদিন, একাধিক টুর্নামেন্ট কুইজ এর পাশাপাশি ক্যাটাগরি কুইজের একাধিক সেগমেন্টে কুইজ খেলার সুযোগ থাকবে ।</li>
                  <li>QUIZARD এর প্রতিটি সেগমেন্টে সর্বোচ্চ ৬০ টি পছন্দের প্রশ্ন থাকবে এবং দৈনিক ২ বার খেলা যাবে ।</li>
                  <li>প্রতি রাউন্ড এ অংশগ্রহণকারীদের প্রদত্ত বিকল্পগুলি থেকে সঠিক উত্তর নির্বাচন করতে হবে। অংশগ্রহণকারীরা প্রতিটি সঠিক উত্তরের জন্য ১ পয়েন্ট অর্জন করবে।</li>
                  <li>কুইজ এর উত্তর জমা দেওয়ার জন্য একটি নির্দিষ্ট সময়সীমা থাকবে।</li>
                  <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
                  <li>Quizard এ যেকোনো সেগমেন্টে উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>বিজয়ীদের পুরস্কার</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <b>বিশেষ দ্রষ্টব্য:</b> একটি নির্দিষ্ট bKash নম্বর দিয়েই Quizard-এর ৪টি দারুন সেগমেন্টে সাবস্ক্রিপশন করতে পারবেন 
                কুইজ প্রতিদিন  |  স্পোর্টস কুইজ |  BCS প্রস্তুতি  |  কুইজ টুর্নামেন্ট ! <br /><br />
                তবে মনে রাখবেন, ওই bKash নম্বরের সাবস্ক্রিপশনগুলো থেকে প্রতি সেগমেন্টে শুধু একটি নম্বরই উইনার হিসেবে নির্বাচিত হবে! <br /><br />

                QUIZARD কর্তৃপক্ষ বিজয়ীদের দৈনিক, সাপ্তাহিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।<br /><br />
                <b>কুইজ প্রতিদিন পুরস্কার:</b><br />
                প্রতিদিন: শীর্ষ ৫০ জন ১০ টাকা bKash ক্যাশ-ইন<br />
                সাপ্তাহিক : শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত bKash ক্যাশ-ইন<br /><br />
                
                <b>স্পোর্টস কুইজ পুরস্কার:</b><br />
                প্রতিদিন: শীর্ষ ৪০ জন ১০ টাকা bKash ক্যাশ-ইন<br />
                সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত<br /><br />
                
                <b>BCS প্রস্তুতি পুরস্কার:</b><br />
                প্রতিদিন: শীর্ষ ৩০ জন ১০ টাকা bKash ক্যাশ-ইন<br />
                সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত<br /><br />

                <b>Tournament Quiz:</b> টুর্নামেন্ট ফরম্যাটে মেগা পুরস্কার<br />
                প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা bKash ক্যাশ-ইন<br />
                ১ম পুরস্কার: টিভি (Samsung 32T4450 32" HD LED Smart TV)<br />
                ২য় পুরস্কার: স্মার্টফোন (Samsung Galaxy A16 5G (6/128 GB))<br />
                ৩য় পুরস্কার: স্মার্টওয়াচ<br />
                ৪র্থ পুরস্কার: ৩০০০ টাকা ক্যাশ ইন<br />
                ৫ম পুরস্কার: ২০০০ টাকা ক্যাশ ইন পুরস্কার<br /><br />

                <b>Quizard এ অন্যান্য পুরস্কার :</b><br />
                <ul>
                  <li>কুইজ প্রতিদিন, স্পোর্টস কুইজ, BCS প্রস্তুতি ও টুর্নামেন্ট বান্ডেল সাবস্ক্রাইব করলে ২০% ক্যাশব্যাক</li>
                  <li>রেফারেল সফল হলে উভয় পক্ষ ১০ টাকা ক্যাশ-ইন পাবে</li>
                  <li>ফিরে আসা ইউজারদের জন্য ১০ টাকা ক্যাশব্যাক</li>
                  <li>নিউ সাবস্ক্রাইবার গন পাবেন ৫ টাকা ক্যাশ ব্যাক প্রাইজ</li>
                </ul>
                
                <b>ব্যাজ অর্জনের পুরস্কার (শীঘ্রই আসছে!):</b><br />
                ব্রোঞ্জ: ২০ টাকা ক্যাশ-ইন<br />
                সিলভার: ৪০ টাকা ক্যাশ-ইন<br />
                গোল্ড: ৫০ টাকা ক্যাশ-ইন<br />
                <br />
                ** আয়োজক সত্তা তার বিবেচনার ভিত্তিতে পুরস্কার পরিবর্তন বা প্রতিস্থাপন করার অধিকার সংরক্ষণ করে ।<br /><br />
                <b>ব্যাজ অর্জনের যোগ্যতাঃ</b><br />
                ব্রোঞ্জ - ১২৬০ স্কোর এ পৌছাতে হবে (৩  সপ্তাহ রিনিউয়াল  থাকতে হবে )<br />
                সিলভার - ২৫২০ স্কোর এ পৌছাতে হবে (৪ সপ্তাহ রিনিউয়াল  থাকতে হবে )<br />
                গোল্ড -  ৩৩৬০ স্কোর এ পৌছাতে হবে (৬ সপ্তাহ রিনিউয়াল  থাকতে হবে )
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ প্রতিদিন এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ৫০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ৫০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>কুইজ প্রতিদিন এ বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                  <li>উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                  <li>সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত bKash ক্যাশ-ইন</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>স্পোর্টস কুইজ এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ৪০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ৪০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                  <li>উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                  <li>সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>BCS প্রস্তুতি কুইজ এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ৩০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ৩০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                  <li>উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                  <li>সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ  টুর্নামেন্ট এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>প্রতিটি টুর্নামেন্ট শেষে অংশগ্রহণকারীদের টোটাল স্কোর ও সময় গণনা করা হবে ।</li>
                  <li>উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                  <li>সর্বনিম্ন সময়ে সর্বোচ্চ স্কোর ধারী ৫ জন কে মেগা পুরস্কার প্রদান করা হবে ।</li>
                  <li>টুর্নামেন্ট এ বিজয়ী হওয়ার জন্য টুর্নামেন্ট চলাকালীন সময় একজন অংশগ্রহণকারী QUIZARD থেকে আনসাবস্ক্রাইব করতে পারবে না । অন্যথায় সর্বোচ্চ স্কোর থাকলেও অযোগ্য হিসেবে ধরা হবে এবং কোনো পুরস্কারের জন্য যোগ্য বিবেচিত হবে না।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>টুর্নামেন্টের নতুন নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>QUIZARD টুর্নামেন্টের প্রতিদিনের রাউন্ড চলমান। যদি কোন  টুর্নামেন্ট প্লেয়ার এখন পর্যন্ত কোনো দিনের রাউন্ড মিস করে থাকেন, তবে তা পুনরায় খেলার সুযোগ রয়েছে।</li>
                  <li>নতুন ও পুরাতন—সব খেলোয়াড়ই মিস করা দিনের রাউন্ড পুনরায় ক্রয় করতে পারবেন এবং সেই দিনের স্কোর অর্জন করে লিডারবোর্ডে এগিয়ে যেতে পারবেন।</li>
                  <li>এই সুবিধাটি কেবল টুর্নামেন্ট চলাকালীন সময়ের জন্য প্রযোজ্য।</li>
                </ul>
                <b>টুর্নামেন্টে এক্সট্রা রাউন্ড কেনার নিয়মাবলী:</b>
                <ul>
                  <li>টুর্নামেন্ট প্লেয়ারদের মধ্যে যারা অতিরিক্ত রাউন্ড কেনার জন্য যোগ্য, তারা প্রতি ২টি রাউন্ড কিনতে পারবেন ৫ টাকায়।</li>
                  <li>একটি পপ-আপ এর মাধ্যমে প্রতিদিন জানিয়ে দেওয়া হবে, আপনি কতটি রাউন্ড কিনতে পারবেন।</li>
                </ul>
                <b>বিশেষ দ্রষ্টব্য:</b>
                <p>টুর্নামেন্ট প্লেয়ার গণ শুধুমাত্র সেই রাউন্ডগুলোই কিনতে পারবেন, যেগুলো তারা মিস করেছেন।</p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>রেফার কোড ব্যাবহারের নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                QUIZARD এর মেন্যু বার থেকে Profile (প্রোফাইল) অপশনে গেলে আপনার রেফার কোড টি পেয়ে যাবেন ।<br />
                <ul>
                  <li>আপনার রেফারেল কোডটি শেয়ার করুন । আপনার রেফার কোড ব্যাবহার করে কেউ যদি সাবস্ক্রিপশন করে, তাহলে প্রতি সফল সাবস্ক্রিপশনে আপনি পেয়ে যাবেন ১০ টাকা ক্যাশ ইন।</li>
                  <li>কারো শেয়ারকৃত রেফার কোড ব্যাবহার করে সাবস্ক্রিপশন করলে, ১ম সাবস্ক্রিপশনে আপনি পেয়ে যাবেন ১০ টাকার ক্যাশ ব্যাক ।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="11" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>সাপ্তাহিক ক্যাম্পেইন এর সময়সীমা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                প্রতি বৃহস্পতিবার থেকে বুধবার পর্যন্ত ।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="12" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ টুর্নামেন্ট এর সময়সীমা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                ১লা জুলাই থেকে ৩১ শে ডিসেম্বর ২০২৫
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="13" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>গোপনীয়তা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                কুইজের সময় সংগৃহীত অংশগ্রহণকারীদের তথ্য শুধুমাত্র খেলা পরিচালনার উদ্দেশ্যে এবং প্রযোজ্য হলে পুরস্কার প্রদানের উদ্দেশ্যে ব্যবহার করা হবে। ব্যক্তিগত তথ্য পূর্ব সম্মতি ছাড়া তৃতীয় পক্ষের সাথে ভাগ করা হবে না।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>বুদ্ধিবৃত্তিক সম্পত্তি</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                প্রশ্ন, উত্তর এবং ছবি সহ সমস্ত কুইজের বিষয়বস্তু হল আয়োজক সত্তার বৌদ্ধিক সম্পত্তি। অননুমোদিত প্রজনন বা বিতরণ নিষিদ্ধ।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>দায়</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                কুইজের সময় ঘটতে পারে এমন কোনও প্রযুক্তিগত সমস্যা, বাধা বা ত্রুটির জন্য আয়োজক সত্তা দায়বদ্ধ নয়। অংশগ্রহণকারীরা যেন তাদের নিজস্ব ঝুঁকিতে খেলে।
              </Accordion.Body>
            </Accordion.Item>

            {((playerData?.isSubscribe) || (playerData?.isSubscribeTournament) || (playerData?.isSubscribeSports) || (playerData?.isSubscribeBcs)) &&             <Accordion.Item eventKey="16" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কিভাবে আন্সাবস্ক্রাইব করবেন</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
              আন্সাবস্ক্রাইব করতে ক্লিক করুন <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={()=>{setShowRefundModal(true);}}>এখানে</span>
              </Accordion.Body>
            </Accordion.Item>}
          </Accordion>
        </div>
      </div>
    </>
  )
}

export default TCModal